module.exports = __webpack_public_path__ + "img/85.7650bf9e.png";